export default __webpack_public_path__ + "static/lam-e9cdd7a4877ff0ab9e07fbebb3f01cfe.png";